import React from "react";
import { FaReceipt, FaPassport, FaHome, FaAnchor } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const servicesData = [
	{
		name: "services.accounting",
		icon: FaReceipt,
		description: "services.accountingDesc",
		gradient: "from-slate-700 to-slate-500",
	},
	{
		name: "services.tax",
		icon: FaAnchor,
		description: [
			"services.taxDesc1",
			"services.taxDesc2",
			"services.taxDesc3",
			"services.taxDesc4",
		],
		gradient: "from-accent to-orange-400",
	},
	{
		name: "services.financialManagement",
		icon: FaHome,
		description: "services.financialManagementDesc",
		gradient: "from-slate-600 to-slate-400",
	},
	{
		name: "services.consulting",
		icon: FaPassport,
		description: [
			"services.consultingDesc1",
			"services.consultingDesc2",
			"services.consultingDesc3",
			"services.consultingDesc4",
			"services.consultingDesc5",
			"services.consultingDesc6",
		],
		gradient: "from-accent-dark to-accent",
	},
];

const Services = () => {
	const { t } = useTranslation();

	return (
		<section
			id="services"
			className="bg-gradient-to-b from-cream to-warm dark:from-slate-900 dark:to-slate-800 dark:text-white py-20 relative overflow-hidden"
		>
			{/* Background decoration */}
			<div className="absolute top-0 left-1/4 w-96 h-96 bg-accent/8 rounded-full blur-3xl"></div>
			<div className="absolute bottom-0 right-1/4 w-96 h-96 bg-slate-400/10 rounded-full blur-3xl"></div>

			<div className="container relative z-10">
				<div className="pb-16 text-center">
					<span className="text-accent font-semibold text-sm tracking-wider animate-fade-in">
						{t("services.intro")}
					</span>
					<h2 className="section-title mt-3 animate-fade-in-up">
						<span className="gradient-text">{t("services.explore")}</span>
					</h2>
				</div>

				<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 lg:gap-8">
					{servicesData.map((service, index) => (
						<div
							key={service.name}
							className={`group relative bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-card hover:shadow-card-hover transition-all duration-500 hover:-translate-y-3 border border-gray-100 dark:border-slate-700 animate-fade-in-up`}
							style={{ animationDelay: `${index * 100}ms` }}
						>
							{/* Icon container with gradient */}
							<div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${service.gradient} flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
								<service.icon className="text-2xl text-white" />
							</div>

							{/* Title */}
							<h3 className="text-xl font-bold mb-3 dark:text-white group-hover:text-accent transition-colors duration-300">
								{t(service.name)}
							</h3>

							{/* Description */}
							{Array.isArray(service.description) ? (
								<ul className="space-y-2">
									{service.description.map((desc, idx) => (
										<li
											key={idx}
											className="flex items-start gap-2 text-gray-600 dark:text-gray-300 text-sm"
										>
											<span className="w-1.5 h-1.5 rounded-full bg-accent mt-2 flex-shrink-0"></span>
											{t(desc)}
										</li>
									))}
								</ul>
							) : (
								<p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed">
									{t(service.description)}
								</p>
							)}

							{/* Hover accent line */}
							<div className={`absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r ${service.gradient} rounded-b-2xl transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left`}></div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Services;
